export type ManufacturerId = {
  manufacturerId?: string;
};
export type ManufacturerBase = {
  name: string;
  code?: string | null;
  isActive: boolean;
  isLocked?: boolean;
};

export type DeleteManufacturerRequest = ManufacturerId;
export type DeleteManufacturerResponse = void;

export type GetManufacturerRequest = ManufacturerId;
export type GetManufacturerResponse = {
  manufacturer: ManufacturerId & ManufacturerBase;
};

export type PostManufacturerResponse = (ManufacturerId & ManufacturerBase)[];
export type PostManufacturerRequest = {
  body: {
    manufacturer: ManufacturerBase | null;
  };
};

export type PatchManufacturerResponse = ManufacturerId;
export type PatchManufacturerRequest = ManufacturerId & {
  body: ManufacturerBase | null;
};

export type GetManufacturersResponse = (ManufacturerBase & ManufacturerId)[];

export type GetManufacturersRequest = void;

export type PutManufacturersRefreshRequest = void;
export type PutManufacturersRefreshResponse = void;
